var _path, _path2, _g, _path3, _path4, _g2, _circle, _circle2, _path5, _path6, _g3, _rect, _rect2, _path7, _rect3, _rect4, _rect5, _rect6, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot61(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.436 76.184C134 77.0397 134 78.1598 134 80.4V127.6C134 129.84 134 130.96 134.436 131.816C134.819 132.569 135.431 133.181 136.184 133.564C137.04 134 138.16 134 140.4 134H163.6C165.84 134 166.96 134 167.816 133.564C168.569 133.181 169.181 132.569 169.564 131.816C170 130.96 170 129.84 170 127.6V118.994C171.35 118.976 172.161 118.898 172.816 118.564C173.569 118.181 174.181 117.569 174.564 116.816C175 115.96 175 114.84 175 112.6V95.4C175 93.1598 175 92.0397 174.564 91.184C174.181 90.4314 173.569 89.8195 172.816 89.436C172.161 89.1021 171.35 89.0239 170 89.0056V80.4C170 78.1598 170 77.0397 169.564 76.184C169.181 75.4314 168.569 74.8195 167.816 74.436C166.96 74 165.84 74 163.6 74H140.4C138.16 74 137.04 74 136.184 74.436C135.431 74.8195 134.819 75.4314 134.436 76.184ZM20.436 83.184C20 84.0397 20 85.1598 20 87.4V97H16.4C14.1598 97 13.0397 97 12.184 97.436C11.4314 97.8195 10.8195 98.4314 10.436 99.184C10 100.04 10 101.16 10 103.4V120.6C10 122.84 10 123.96 10.436 124.816C10.8195 125.569 11.4314 126.181 12.184 126.564C13.0397 127 14.1598 127 16.4 127H39.6C41.8402 127 42.9603 127 43.816 126.564C44.5686 126.181 45.1805 125.569 45.564 124.816C46 123.96 46 122.84 46 120.6V104.6V103.4V87.4C46 85.1598 46 84.0397 45.564 83.184C45.1805 82.4314 44.5686 81.8195 43.816 81.436C42.9603 81 41.8402 81 39.6 81H26.4C24.1598 81 23.0397 81 22.184 81.436C21.4314 81.8195 20.8195 82.4314 20.436 83.184Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_34",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 74,
    width: 165,
    height: 60
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.436 76.184C134 77.0397 134 78.1598 134 80.4V127.6C134 129.84 134 130.96 134.436 131.816C134.819 132.569 135.431 133.181 136.184 133.564C137.04 134 138.16 134 140.4 134H163.6C165.84 134 166.96 134 167.816 133.564C168.569 133.181 169.181 132.569 169.564 131.816C170 130.96 170 129.84 170 127.6V118.994C171.35 118.976 172.161 118.898 172.816 118.564C173.569 118.181 174.181 117.569 174.564 116.816C175 115.96 175 114.84 175 112.6V95.4C175 93.1598 175 92.0397 174.564 91.184C174.181 90.4314 173.569 89.8195 172.816 89.436C172.161 89.1021 171.35 89.0239 170 89.0056V80.4C170 78.1598 170 77.0397 169.564 76.184C169.181 75.4314 168.569 74.8195 167.816 74.436C166.96 74 165.84 74 163.6 74H140.4C138.16 74 137.04 74 136.184 74.436C135.431 74.8195 134.819 75.4314 134.436 76.184ZM20.436 83.184C20 84.0397 20 85.1598 20 87.4V97H16.4C14.1598 97 13.0397 97 12.184 97.436C11.4314 97.8195 10.8195 98.4314 10.436 99.184C10 100.04 10 101.16 10 103.4V120.6C10 122.84 10 123.96 10.436 124.816C10.8195 125.569 11.4314 126.181 12.184 126.564C13.0397 127 14.1598 127 16.4 127H39.6C41.8402 127 42.9603 127 43.816 126.564C44.5686 126.181 45.1805 125.569 45.564 124.816C46 123.96 46 122.84 46 120.6V104.6V103.4V87.4C46 85.1598 46 84.0397 45.564 83.184C45.1805 82.4314 44.5686 81.8195 43.816 81.436C42.9603 81 41.8402 81 39.6 81H26.4C24.1598 81 23.0397 81 22.184 81.436C21.4314 81.8195 20.8195 82.4314 20.436 83.184Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_34)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 66,
    width: 180,
    height: 76,
    fill: "#4DD0E1"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 113,
    width: 180,
    height: 29,
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 86,
    r: 5,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 102,
    r: 5,
    fill: "white",
    fillOpacity: 0.6
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93 5H89V36H81C79.8954 36 79 36.8954 79 38V52H103V38C103 36.8954 102.105 36 101 36H93V5Z",
    fill: "#E1E6E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_34",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 5,
    width: 24,
    height: 47
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93 5H89V36H81C79.8954 36 79 36.8954 79 38V52H103V38C103 36.8954 102.105 36 101 36H93V5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_34)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    width: 100,
    height: 52,
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 36,
    width: 24,
    height: 16,
    fill: "white",
    fillOpacity: 0.2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 8,
    r: 8,
    fill: "#FFE65C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 5,
    r: 3,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 146V112.852C25 108.317 25.7711 103.815 27.2804 99.5389L44.7614 56.0092C47.3014 48.8126 54.1036 44 61.7353 44L118.265 44C125.896 44 132.699 48.8126 135.239 56.0092L152.72 99.5389C154.229 103.815 155 108.317 155 112.852V146C155 155.941 146.941 164 137 164H43C33.0589 164 25 155.941 25 146Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_34",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 146V112.852C25 108.317 25.7711 103.815 27.2804 99.5389L44.7614 56.0092C47.3014 48.8126 54.1036 44 61.7353 44L118.265 44C125.896 44 132.699 48.8126 135.239 56.0092L152.72 99.5389C154.229 103.815 155 108.317 155 112.852V146C155 155.941 146.941 164 137 164H43C33.0589 164 25 155.941 25 146Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_34)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 42,
    width: 134,
    height: 124,
    fill: "#00ACC1"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 128,
    width: 68,
    height: 24,
    rx: 5,
    fill: "black",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 132,
    width: 60,
    height: 16,
    rx: 2,
    fill: "black",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61 141H72L74 137L77 144L81 136L83 145L86 134L89 144L92 141H107L110 137L112 144L115 141H119",
    stroke: "#4EFAC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 80,
    width: 104,
    height: 42,
    rx: 4,
    fill: "black",
    fillOpacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 101,
    width: 10,
    height: 11,
    rx: 2,
    fill: "#8BDDFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 101,
    width: 10,
    height: 11,
    rx: 2,
    fill: "#8BDDFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 80H67L50 122H42L59 80Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot61);
export default __webpack_public_path__ + "static/media/bot-6-1.1aa80b23b35f4e14ba9c7488449b995a.svg";
export { ForwardRef as ReactComponent };